import { useState } from "react";
import { Button } from "V2.0/common/button";
import { PlusIcon } from "@heroicons/react/24/outline";

import KeyValuePairsTable from "../Components/KeyValuePairs/KeyValuePairsTable";
import useKeyValuePairsForm from "../Components/KeyValuePairs/useKeyValuePairsForm";
import KeyValuePairFormDialog from "../Components/KeyValuePairs/KeyValuePairFormDialog";

export default function Headers(props) {
  const { headers, onUpdate } = props;

  const [headerDialog, setHeaderDialog] = useState({
    mode: undefined,
    key: "",
    value: "",
  });

  const { addKeyValuePair, removeKeyValuePair, updateKeyValuePair } =
    useKeyValuePairsForm(headers, onUpdate);

  return (
    <>
      <div className="flex flex-col gap-y-4">
        <div className="flex items-center justify-between">
          <p className="text-sm font-semibold">Headers</p>
          <Button
            outline
            onClick={() => setHeaderDialog({ mode: "add", key: "", value: "" })}
          >
            <PlusIcon /> Header
          </Button>
        </div>
        <div>
          <KeyValuePairsTable
            keyValuePairs={headers}
            onKeyValuePairEdit={(key, value) => {
              setHeaderDialog({ mode: "edit", key, value });
            }}
            onKeyValuePairRemove={(key) => removeKeyValuePair(key)}
          />
        </div>
      </div>
      {headerDialog.mode && (
        <KeyValuePairFormDialog
          title="Header"
          mode={headerDialog.mode}
          keyValuePair={{
            key: headerDialog.key,
            value: headerDialog.value,
          }}
          onAdd={addKeyValuePair}
          onUpdate={updateKeyValuePair}
          onClose={() =>
            setHeaderDialog({ mode: undefined, key: "", value: "" })
          }
        />
      )}
    </>
  );
}
